module.exports = __webpack_public_path__ + "img/icon_trade_contract_trade_result.00143982.svg";